<template>
  <b-container fluid>
    <backlink/>
    <h1>Paramètres</h1>

    <AdminTable :config="config" :options="options"></AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTable";
import config from "./config";

export default {
  name: "MyaxilocSettingList",
  components: {
    AdminTable
  },
  data() {
    return {
      config: config
    };
  },
  computed: {
    options: function() {
      return {
        context_slug_options: this.$store.getters["myaxiloc_setting/getTypes"]
      };
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/MyaxilocSetting/MyaxilocSettingList.vue